
import { dateFormat } from '@/common/utils/utils'
// import Axios from '@/api/diyaxios'
// import Axios from 'axios'
import { insertPointFun } from '@/api/pages.js'   //添加埋点
import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js';
export function insertPoint(params, actionType, eventId, doId){
    let url = '/tk/action/insert';
    let param = {
            actionType: actionType,
            eventId: eventId,
            doId: doId,
            data: JSON.stringify(params),
            startTime: dateFormat(new Date(), 'yyyy-MM-dd h:m:s')
    }
  param.timestamp = new Date().getTime();
  const secretKey = 'TwPp-a7AZ-Nk92-B1u';
  const paramString = Object.keys(param).filter(key => param[key] !== null && param[key] !== undefined && param[key] !== '' && Array.isArray(param[key])
    === false && typeof param[key] === 'object' === false).sort().map(key => `${key}=${param[key]}`).join('&');
  const signatures = CryptoJS.MD5(paramString + secretKey).toString();
  param.signature = signatures;
    let res = insertPointFun(param);
    if(res.status){
        console.log('添加埋点成功~！');
    }
    // Axios.post(url, param, {
    //     headers:{
    //         'Content-Type':'application/json',
    //         'userId': encodeURI(Cookies.get('UserID')), //
    //         'userName': encodeURI(Cookies.get('name')),
    //         'orgGid': encodeURI(Cookies.get('orgGid')),
    //         'orgName': encodeURI(Cookies.get('orgName'))
    //     }
    // }).then(res => {
    //     if(res.status){
    //         console.log('添加埋点成功~！');
    //     }
    // }).catch(res => {
    //         console.log(res.msg);
    // })
}




// WEBPACK FOOTER //
// ./src/api/insertPoints.js